import m from '@bitstillery/mithril'
import {MithrilComponent} from '@bitstillery/mithril'
import {Button, Icon} from '@bitstillery/common/components/portal'
import {format_money_with_symbol} from '@bitstillery/common/lib/format'
import {classes} from '@bitstillery/common/lib/utils'

import {OrderItems} from '@/components/order_items/order_items'

import {CollectionRecommendations} from '@/components/pages/offers/lib/collection_recommendations'
import {$m, $s} from '@/app'
import {panel_cart_peek_units} from '@/components/panels/panel_cart/panel_cart_state'
import {PanelCart} from '@/components/panels'

export class Checkout extends MithrilComponent {
    private toggle_cart() {
        if ($s.panels.context.collapsed) {
            $s.panels.view.menu.collapsed = true
        }
        $s.panels.context.collapsed = !$s.panels.context.collapsed
    }

    view(_vn: m.Vnode) {
        if ($s.cart.loading && !$s.cart.artkey) {
            return
        }

        return (
            <div className={classes('c-checkout', 'shop-grid', 'shop-grid--no-filters')}>
                <div
                    className={classes('shop-backdrop', {
                        'shop-backdrop-visible': !$s.panels.context.collapsed,
                    })}
                    onclick={() => {
                        $s.panels.view.menu.collapsed = true
                        $s.panels.context.collapsed = true
                    }}
                />

                <div className='view'>
                    <div className='finalize-cart'>
                        <OrderItems variant='wide' />
                        <CollectionRecommendations />
                    </div>
                </div>

                <PanelCart mode='checkout' />

                {/* Tablet cart toggle */}
                <div className='shop-cart-toggle'>
                    <Button active={!$s.panels.context.collapsed} icon='cart' onclick={() => this.toggle_cart()} type='info'>
                        {$m.cart.cart_units() > 0 ? (
                            <span className='shop-cart-toggle-badge'>
                                {$m.cart.cart_units() > 999 ? '999+' : String($m.cart.cart_units())}
                            </span>
                        ) : null}
                    </Button>
                </div>

                {/* Mobile cart toggle */}
                {$m.cart.cart_amount_validated() > 0 || $m.cart.booked_amount() > 0 ? (
                    <div className='shop-bottom-bar shop-bottom-bar--cart-peek shop-bottom-bar--peek-only shop-checkout-mobile-cart-peek'>
                        <button
                            className={classes('shop-mobile-cart-peek', {active: !$s.panels.context.collapsed})}
                            type='button'
                            onclick={() => this.toggle_cart()}
                        >
                            <Icon name='cart' size='s' type='unset' />
                            <span className='shop-mobile-cart-peek-count'>{panel_cart_peek_units()}</span>
                            <span className='shop-mobile-cart-peek-total'>
                                {format_money_with_symbol(
                                    $m.cart.total_amount_validated(),
                                    $s.identity.user.currency,
                                    $s.language,
                                )}
                            </span>
                        </button>
                    </div>
                ) : null}
            </div>
        )
    }
}
